import { Injectable } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { EventProperties, ProductProperties, SearchProperties } from '@avo/interface/trigger-props';
import { AppFacade } from '@app/app.facade';
import { TriggerAmplitudeEntity } from '@amplitude/interfaces/trigger-entity';
import { MobileDeviceService } from '@app/services/mobile-device.service';
import { getTriggerEvent, getEventProps } from '@avo/mappers/trigger-event.mapper';

@Injectable()
export class TriggerAmplitudeService {

  constructor(
    private readonly appFacade: AppFacade,
    private readonly mobileDeviceService: MobileDeviceService,
  ) { }

  public trackAmplitudeEventProps$(
    eventName: string = null,
    eventParams: EventProperties = {},
    searchProps: SearchProperties = null,
    productProps: ProductProperties = null
  ): Observable<TriggerAmplitudeEntity> {
    return zip(
      this.appFacade.user$,
      this.appFacade.userAddresses$,
      this.appFacade.trackingUtm$,
      this.mobileDeviceService.isMobileDevice$
    ).pipe(
      map(([user, userAddresses, utms, isMobile]) => {
        return getTriggerEvent(
          eventName, getEventProps(isMobile, utms, eventParams),
          searchProps, productProps, userAddresses, user
        );
      })
    );
  }

}
